const url = import.meta.env.VITE_APP_API_AUTH

export default {
    namespaced: true,
    actions: {
        fetchCountry: async ({ commit }) => {
            commit('SET_COUNTRY_LOADING_STATUS', true)
            const  resJson = await fetch(`${url}/security/get-countries`)
            const res = await resJson.json()
            if(res.code === 200) {
                commit('SET_COUNTRY_LOADING_STATUS', false)
                commit('SET_COUNTRY_LIST', res.data)
                return res.data
            } else {
                commit('SET_COUNTRY_LOADING_STATUS', false)
            }
        },
        fetchTimezone: async ({ commit }) => {
            commit('SET_TIMEZONE_LOADING_STATUS', true)
            const  resJson = await fetch(`${url}/security/get-timezones`)
            const res = await resJson.json()
            if(res.code === 200) {
                commit('SET_TIMEZONE_LOADING_STATUS', false)
                commit('SET_TIMEZONE_LIST', res.data)
                return res.data
            } else {
                commit('SET_TIMEZONE_LOADING_STATUS', false)
            }
        },
    },
    mutations: {
        SET_COUNTRY_LIST(state, list) {
            state.countryList = list
        },
        SET_COUNTRY_LOADING_STATUS(state, status) {
            state.countryLoading = status
        },
        SET_TIMEZONE_LIST(state, list) {
            state.timezoneList = list
        },
        SET_TIMEZONE_LOADING_STATUS(state, status) {
            state.timezoneLoading = status
        },
    },
    state: {
        countryList: undefined,
        timezoneList: undefined,
        countryLoading: false,
        timezoneLoading: false,
    },
    getters: {
        getList:(state) => state.countryList,
    }
}